import { AttachedPropertyValue, Component, View, ViewModel } from "binder";
import  { GridView } from "./grid-view"

export class GridViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new GridView();
    }
    public getTypeId(): string {
        return "VM-7390EDE7-11F7-4008-B12A-19C43B544F70"
    }

    
    public set columndefinition(v: string) { this._columndefinition = v; } public get columndefinition(): string { return this._columndefinition;} private _columndefinition: string;
    public set rowdefinition(v: string) { this._rowdefinition = v; } public get rowdefinition(): string { return this._rowdefinition;} private _rowdefinition: string;
    
    public set column(v: AttachedPropertyValue) { this._column = v; } public get column(): AttachedPropertyValue { return this._column;} private _column: AttachedPropertyValue;
    public set row(v: AttachedPropertyValue) { this._row = v; } public get row(): AttachedPropertyValue { return this._row;} private _row: AttachedPropertyValue;
    public set columnspan(v: AttachedPropertyValue) { this._columnspan = v; } public get columnspan(): AttachedPropertyValue { return this._columnspan;} private _columnspan: AttachedPropertyValue;
    public set rowspan(v: AttachedPropertyValue) { this._rowspan = v; } public get rowspan(): AttachedPropertyValue { return this._rowspan;} private _rowspan: AttachedPropertyValue;
}
